/* eslint-disable prettier/prettier */
/* eslint-disable curly */
import { useLazyQuery } from "@vue/apollo-composable";
import { GetPageDocument } from "@/core/api/graphql/types";
import type { GetPageQuery, GetPageQueryVariables } from "@/core/api/graphql/types";
import type { MaybeRefOrGetter } from "vue";

export function useGetPage(payload: MaybeRefOrGetter<GetPageQueryVariables>) {
  return useLazyQuery(GetPageDocument, payload, { fetchPolicy: "no-cache" });
}

export async function getPage(pageQueryParameters: GetPageQueryVariables) : Promise<GetPageQuery | undefined>
{
  const pageQuery = useLazyQuery(GetPageDocument, pageQueryParameters, { fetchPolicy: "cache-first" });
  const result = await pageQuery.load();

  if (pageQuery.error.value)
    throw `Error fetching page by params '${JSON.stringify(pageQueryParameters)}': ${JSON.stringify(pageQuery.error.value)}`;

  if (result)
    return result;
  
  return undefined;
}